import Icon from '../components/Icon.vue'

Icon.register({"share":{"width":512,"height":512,"paths":[{"d":"M503.7 189.8L327.7 37.9C312.3 24.5 288 35.3 288 56V136.1C127.4 137.9 0 170.1 0 322.3 0 383.8 39.6 444.6 83.3 476.5 97 486.4 116.4 473.9 111.4 457.8 66.1 312.8 132.9 274.3 288 272.1V360C288 380.7 312.3 391.5 327.7 378.2L503.7 226.2C514.8 216.6 514.8 199.4 503.7 189.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/share.js
// module id = bgzz
// module chunks = 0